export default "__VITE_ASSET__DqfIpAg$__"